import { actions } from './nationality/actions'
import { getters } from './nationality/getters'
import { state } from './nationality/state'
import { mutations } from './nationality/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
